
import ImageHeader from '@/components/core/ImageHeader';
import tableLoading from '@/components/tableLoading';
import NoContent from '@/components/customer-content/NoContent'
import CouponSlick from '@/components/CouponSection/CouponSlick'
import Coupon from '@/components/CouponSection/Coupon'
import PlaceCard from '../../../components/PlaceCard.vue';
export default {
  scrollToTop: true,
  components: {
    ImageHeader,
    tableLoading,
    NoContent,
    CouponSlick,
    Coupon
  },
  head() {
    return {
      title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaDesc()
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: this.metaKeywords()
      },
      {
        hid: 'image',
        property: 'image',
        content: this.metaImage
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.metaDesc()
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.metaImage
      },
      {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: this.metaImage
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.metaImage
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.metaDesc()
      }

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Top Activities and Offers',
      description: 'Goa App | Discover Beaches, Churches, Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals in Goa.',
      keywords: '',
      metaImage: '',
      selectedValue: null,
      search: '',
      isSearchClicked: false,
      pageData: {
        categories: null,
        activities: null
      },
      filters: {
        categories: [],
        allCategory: true,
        sortBy: 'popular',
      },
      applyFilterClicked: false,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      listings: {},
      itemSelected: -1,
      schemaData: [],
      loading: true,
      listingLoading: true,
      coupons: null,
      activityCat: null,
      pageTitle: 'Activities',
      pageSubTitle: 'Popular Adventure Tourism Activities in Goa',
      apiCallName: null,
      seoData: null,
      featuredCats: null,
      featuredCatsLoading: true,
      eventCategoryModal: false,
    };
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.slug != (null || "")) {
      this.activityCat = params.slug;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.activityCat = this.$route.params.slug;
  },

  async fetch() {
    this.seoData = await fetch(this.$config.fetchUrl + '/api/posts/seo/getCategorySEOContent/' + this.activityCat)
      .then(res => res.json()).catch(error => {
        //this.$router.push({
//          path: '/'
//        })
        console.error("There was an error!", error); return false;
      });
    if (this.seoData.image) {
      this.metaImage = this.seoData.image;
    }
  },


  jsonld() {
    return {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: this.schemaData.map((itm, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          "name": itm.post && itm.post.title ? itm.post.title : 'Goa App',
          "description": itm.post && itm.post.description ? itm.post.description : 'One of the things you must do in Goa.',
          "image": itm.post && itm.post.gallery && itm.post.gallery.length > 0 ? itm.post.gallery : [],
          "brand": {
            "@type": "Brand",
            "name": "Goa App"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "bestRating": "5",
            "ratingCount": "89",
            "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '5',
            "reviewCount": itm.post && itm.post.views ? String(itm.post.views.count).slice(0, 2) : '5',
          },
          "offers": {
            "@type": "Offer",
            "price": itm.seller ? 0 : 0,
            "priceValidUntil": "2025-12-31",
            "priceCurrency": "INR",
            "availability": "InStock",
            "seller": {
              "@type": "Organization",
              "name": "Goa App"
            },
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "IN",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 10,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/FreeReturn"
            },
            "shippingDetails": {
              "@type": "OfferShippingDetails",
              "deliveryTime": {
                "@type": "ShippingDeliveryTime",
                "businessDays": {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "https://schema.org/Monday",
                    "https://schema.org/Tuesday",
                    "https://schema.org/Wednesday",
                    "https://schema.org/Thursday",
                    "https://schema.org/Friday"
                  ]
                },
                "cutoffTime": "12:00:15Z",
                "handlingTime": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 2,
                  "unitCode": "d"
                },
                "transitTime": {
                  "@type": "QuantitativeValue",
                  "minValue": 1,
                  "maxValue": 10,
                  "unitCode": "d"
                }
              },
              "shippingRate": {
                "@type": "MonetaryAmount",
                "value": "0",
                "currency": "INR"
              },
              "shippingDestination": [
                {
                  "@type": "DefinedRegion",
                  "addressCountry": "IN",
                  "addressRegion": ["GA"]
                }
              ]
            }
          }
        },
      })),
    };
  },

  mounted() {
    this.getListings();
    this.getActitvitesCategoriesData();
  },
  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },
  computed: {
    disableSearch() {
      let searchStr = "";
      if (this.search)
        searchStr = this.search.trim()
      const re = /^[a-zA-Z0-9\s,-]{3,}/;
      return re.test(String(searchStr).toLowerCase());
    }
  },
  methods: {

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForPlacesPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

    getSlugTitle(key) {
      let val = key.replace(/-/g, " ")
      return val
    },

    metaDesc() {
      if (this.seoData && this.seoData.description) {
        return this.seoData.description
      } else {
        return 'Looking for the must visit places and must do activities in Goa ? Goa App offers all that you need to know about the Beaches, Old Goa Churches Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals etc. Check out the top things to do in Goa only on Goa App.'
      }
    },
    metaKeywords() {
      if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
      } else {
        return 'Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency'
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },
    // TO get SUBSCRIPTIONS using pagination
    getListings() {
      //this.listingLoading = true;


      //For get activities api
      // Add header for the API
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      // AXIOS api call to add review api
      // this.$axios.post("/api/posts/app/getPostsOfType/activities", formData, {
      //     headers: headers
      //   })
      this.$axios.get(
        `/api/posts/app/getPlacesCategoryData/${this.activityCat}`
      )
        .then(response => {
          let value = this.getCryptKey(response.data);
          this.listings = value;
          this.schemaData = this.listings && this.listings.length > 0 ? this.listings : [];
          this.$nextTick(() => {
            //this.scrollToSectionIntoView('listing-card');
            this.listingLoading = false;
            this.applyFilterClicked = false;
          })
        })
        .catch(error => {
          this.$nextTick(() => {
            this.listingLoading = false;
            this.applyFilterClicked = false;
          })
        })
        .finally(() => {
          this.$nextTick(() => {
            this.listingLoading = false;
            this.applyFilterClicked = false;
          })
        })
    },
  }
}
